import React from "react";
import SupportShell from "./SupportShell";

// Wraps any existing page component inside the SupportShell (top nav + search).
// Use this for queue pages and admin tools so they share the same header.
export default function withSupportShell<P extends object>(
  Component: React.ComponentType<P>
): React.FC<P> {
  const Wrapped: React.FC<P> = props => (
    <SupportShell>
      <Component {...(props as any)} />
    </SupportShell>
  );
  Wrapped.displayName = `withSupportShell(${Component.displayName || Component.name || "Page"})`;
  return Wrapped;
}
